import { ACTIONS } from "../../common/constants";

const contactInfoDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_CONTACT_INFO_DATA:
      return action.data;
    default:
      return state;
  }
};

export default contactInfoDataReducer;
